import { createSlice } from '@reduxjs/toolkit'

export const chartDataSlice = createSlice({
  name: 'chartData',
  initialState: {
    value: {}
  },
  reducers: {
    setChartData: (state, action) => {
      state.value = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setChartData } = chartDataSlice.actions

export default chartDataSlice.reducer